import React from 'react';
import menuIcons from '../../../atoms/material-icons/icon-mapping';
import './tabs.m.css';

const Tabs = ({ tabs, activeIndex, onChange, darkMode = false }) => {
  return (
    <div styleName={darkMode ? 'tabs dark' : 'tabs'}>
      {tabs.map((tab, index) => (
        <button
          key={tab.label}
          styleName={`tab ${activeIndex === index ? 'active' : ''}`}
          onClick={() => onChange(index)}
        >
          <>
            {Object.keys(menuIcons).includes(tab.icon) !== true
              ? menuIcons.default
              : menuIcons[tab.icon]}
          </>
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
